import { setContext } from "@apollo/client/link/context";
import { getSessionToken, getSessionApiUrl } from "/imports/api/accounts/client/user-session";

export const getHeaders = () => {
  // get the authentication token from local storage if it exists
  const token = getSessionToken();
  const apiServer = getSessionApiUrl();

  // return the headers to the context so httpLink can read them
  return {
    authorization: token ? `Bearer ${token}` : "",
    TM_apiServer: apiServer
  };
};

const authLink = setContext((_, { headers }) =>

  // return the headers to the context so httpLink can read them
  ({
    headers: {
      ...headers,
      ...getHeaders()
    }
  }));

export default authLink;
